document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.jp-events__app').forEach((app) => {
    const raw = app.getAttribute('data-events') || '[]';
    let events = [];
    try { events = JSON.parse(raw); } catch (e) { events = []; }

    // Parse + normalize
    const parsed = events
      .map(ev => ({
        ...ev,
        dateObj: ev.date ? new Date(ev.date + 'T00:00:00') : null
      }))
      .filter(ev => ev.dateObj && !isNaN(ev.dateObj.getTime()))
      .sort((a,b) => a.dateObj - b.dateObj);

    const calEl = app.querySelector('.jp-events__calendar');
    const cardsEl = app.querySelector('.jp-events__cards');
    const monthSelect = app.closest('.jp-events').querySelector('.jp-events__month');
    const todayBtn = app.closest('.jp-events').querySelector('.jp-events__today');

    const weekStart = app.getAttribute('data-week-start') === 'monday' ? 1 : 0; // 0 Sun, 1 Mon

    const monthKeys = Array.from(new Set(parsed.map(ev => `${ev.dateObj.getFullYear()}-${String(ev.dateObj.getMonth()+1).padStart(2,'0')}`)));

    // Fill month dropdown
    monthSelect.innerHTML = monthKeys.map(k => {
      const [y,m] = k.split('-').map(Number);
      const label = new Date(y, m-1, 1).toLocaleString(undefined, { month: 'long', year: 'numeric' });
      return `<option value="${k}">${label}</option>`;
    }).join('');

    const today = new Date();
    const todayKey = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}`;
    monthSelect.value = monthKeys.includes(todayKey) ? todayKey : (monthKeys[0] || todayKey);

    function fmtDay(d) {
      return d.toLocaleString(undefined, { weekday:'long', month:'long', day:'numeric' });
    }

    function fmtShort(d) {
      return d.toLocaleString(undefined, { month:'short', day:'2-digit' });
    }

    function renderList(activeKey) {
      const [y,m] = activeKey.split('-').map(Number);
      const monthEvents = parsed.filter(ev => ev.dateObj.getFullYear() === y && (ev.dateObj.getMonth()+1) === m);

      cardsEl.innerHTML = monthEvents.map(ev => {
        const time = [ev.start, ev.end].filter(Boolean).join(' – ');
        const meta = [time, ev.location].filter(Boolean).join(' · ');
        const link = ev.link ? `<a class="jp-event__link" href="${ev.link}">Tickets / details</a>` : '';
        const details = ev.details ? `<div class="jp-event__meta">${ev.details}</div>` : '';
        return `
          <article class="jp-event" id="event-${ev.id}">
            <div class="jp-event__date">${fmtShort(ev.dateObj)}</div>
            <div class="jp-event__body">
              <h3 class="jp-event__title">${ev.title || 'Event'}</h3>
              ${meta ? `<div class="jp-event__meta">${meta}</div>` : ''}
              ${details}
              ${link}
            </div>
          </article>
        `;
      }).join('') || `<div class="jp-event__meta">No events in this month.</div>`;
    }

    function renderCalendar(activeKey) {
      const [y,m] = activeKey.split('-').map(Number);
      const first = new Date(y, m-1, 1);
      const last = new Date(y, m, 0);
      const daysInMonth = last.getDate();

      // Weekday headers
      const dowsSun = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const dows = weekStart === 1 ? [...dowsSun.slice(1), dowsSun[0]] : dowsSun;

      const monthEvents = parsed.filter(ev => ev.dateObj.getFullYear() === y && (ev.dateObj.getMonth()+1) === m);
      const eventDays = new Set(monthEvents.map(ev => ev.dateObj.getDate()));

      // offset
      let offset = first.getDay(); // 0 Sun..6 Sat
      if (weekStart === 1) offset = (offset + 6) % 7; // convert so Monday=0

      let html = `<div class="jp-cal__head">${dows.map(d => `<div class="jp-cal__dow">${d}</div>`).join('')}</div>`;
      html += `<div class="jp-cal__grid">`;

      // leading blanks
      for (let i=0; i<offset; i++) {
        html += `<div class="jp-cal__cell is-muted"></div>`;
      }

      for (let day=1; day<=daysInMonth; day++) {
        const isToday = (y === today.getFullYear() && (m-1) === today.getMonth() && day === today.getDate());
        const hasEvent = eventDays.has(day);
        const cls = [
          'jp-cal__cell',
          isToday ? 'is-today' : '',
          hasEvent ? 'is-clickable' : ''
        ].filter(Boolean).join(' ');

        html += `
          <div class="${cls}" data-day="${day}">
            <div class="jp-cal__num">${day}</div>
            ${hasEvent ? `<span class="jp-cal__dot" aria-hidden="true"></span>` : ``}
          </div>
        `;
      }

      html += `</div>`;
      calEl.innerHTML = html;

      // click day -> scroll to first event
      calEl.querySelectorAll('.jp-cal__cell.is-clickable').forEach(cell => {
        cell.addEventListener('click', () => {
          const day = Number(cell.getAttribute('data-day'));
          const firstEvent = monthEvents.find(ev => ev.dateObj.getDate() === day);
          if (!firstEvent) return;
          const target = document.getElementById(`event-${firstEvent.id}`);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function renderAll() {
      const key = monthSelect.value || todayKey;
      renderCalendar(key);
      renderList(key);
    }

    monthSelect.addEventListener('change', renderAll);
    todayBtn.addEventListener('click', () => {
      monthSelect.value = monthKeys.includes(todayKey) ? todayKey : (monthKeys[0] || todayKey);
      renderAll();
    });

    renderAll();
  });
});
